export interface queryParams {
	[p: string]: string | number | boolean;
}

export function createQueryParams(params: queryParams, limit?: string): string {
	const addLimit = limit ? `limit=${limit}` : '';
	const basicUrl = Object.keys(params)
		.map((key) => key + '=' + params[key])
		.join('&');
	return basicUrl ? `?${basicUrl}&${addLimit}` : `?${addLimit}`;
}
